import { render, staticRenderFns } from "./TrainerTag.vue?vue&type=template&id=77672f03&scoped=true&"
import script from "./TrainerTag.vue?vue&type=script&lang=js&"
export * from "./TrainerTag.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/trainer_tag.css?vue&type=style&index=0&id=77672f03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77672f03",
  null
  
)

export default component.exports